import { KeyboardEvent } from 'react'
import { Typography } from '@material-ui/core'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Dispatch } from 'redux'
import { reduxForm } from 'redux-form'
import { resendActivationEmail } from '../../../actions/users'
import SubmitFormButton from '../../../components/Buttons/SubmitFormButton'
import ErrorMessage from '../../../components/Error/ErrorMessage'
import { ReduxFormField } from '../../../components/FormInput/ReduxWrappers'
import { selectNotConfirmedEmail } from '../../../selectors/users'
import { MuiClasses } from '../../../types'
import { StateInterface } from '../../../types/states'
import {
  validateEmail,
  noSpaceValue,
  required
} from '../../../utils/validation/forms'

const stripSpaces = (value?: string) =>
  typeof value === 'string' ? value.replace(/\s/g, '') : value

interface Props extends WithTranslation {
  handleSubmit: (arg: any) => any
  resendActivationEmail: (arg: string) => void
  notConfirmedEmail: string | null
  submitting: boolean
  loginUser: (arg: any) => any
  error: string
  classes: MuiClasses
  autoLoggingIn?: boolean
}

const LoginForm = ({
  handleSubmit,
  resendActivationEmail,
  notConfirmedEmail,
  submitting,
  loginUser,
  error,
  t,
  classes,
  autoLoggingIn
}: Props) => {
  const isLoggingIn = submitting || !!autoLoggingIn
  return (
    <form onSubmit={handleSubmit(loginUser)}>
      <ReduxFormField
        name='email'
        label={t('person.loginEmail')}
        autoComplete='username'
        validate={[required, noSpaceValue, validateEmail]}
        normalize={stripSpaces}
        inputProps={{
          onKeyDown: (event: KeyboardEvent<HTMLInputElement>) => {
            if (event.key === ' ') {
              event.preventDefault()
            }
          }
        }}
        required
      />
      <ReduxFormField
        name='password'
        label={t('person.loginPassword')}
        type='password'
        autoComplete='current-password'
        validate={[required, noSpaceValue]}
        required
      />
      <SubmitFormButton
        submitting={isLoggingIn}
        label={isLoggingIn ? 'login.loggingIn' : 'login.login'}
        fullWidth
        classes={classes}
        spinnerColor='#fff'
      />
      <ErrorMessage error={error} />
      {error && notConfirmedEmail && (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a
          href='#'
          onClick={(e) => {
            e.preventDefault()
            if (notConfirmedEmail) {
              resendActivationEmail(notConfirmedEmail)
            }
          }}
        >
          <Typography className={classes.signup} variant='body2' gutterBottom>
            {t('login.resendActivationEmail')}
          </Typography>
        </a>
      )}
      <Link to='/forgotpassword/request'>
        <Typography className={classes.signup} variant='body2' gutterBottom>
          {t('login.forgotPassword')}
        </Typography>
      </Link>
      <Link to='/signup'>
        <Typography className={classes.signup} variant='body2' gutterBottom>
          {t('login.noAccountYet')}
        </Typography>
      </Link>
    </form>
  )
}

const mapStateToProps = (state: StateInterface) => ({
  notConfirmedEmail: selectNotConfirmedEmail(state)
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  resendActivationEmail: (arg: string) => {
    dispatch(resendActivationEmail(arg))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'LoginForm'
  })(withTranslation()(LoginForm as any) as any) as any
) as any
